import { graphql, useStaticQuery } from 'gatsby'

export const useReferAFriendApiData = () => {
  const data = useStaticQuery(graphql`
    {
      referAFriendApi {
        values {
          content {
            refer_a_friend {
              text
              sub_text
              steps_title
              conditions
              steps {
                label
                content
              }
              cta_logged_out {
                link
                action_text
              }
              cta_logged_in {
                link
                action_text
              }
              banner_image_mobile {
                url
                width
              }
              banner_image_desktop {
                url
                width
              }
            }
            faq {
              faq_title
              tc_title
              tc_rows {
                description
                title
              }
              faq_rows {
                answer
                question
              }
              steps_title
              steps {
                label
                content
              }
            }
          }
        }
      }
    }
  `)

  const referAFriendApi = data?.referAFriendApi?.values?.[0]?.content?.[0]

  const content = referAFriendApi?.refer_a_friend
  const faq = referAFriendApi?.faq

  return {
    content,
    faq,
  }
}
